import { Grid, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import HistoryIcon from '@mui/icons-material/History';
import { ACCOUNTS_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler, useState } from 'react';
import { HistoryAllModal } from '../../detail/interactionHistory/HistoryAllModal';
import { AccountsListActionsProps } from './props';

export const AccountsListActions = ({ account }: AccountsListActionsProps) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleEdit: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        navigate(`${ACCOUNTS_EDIT}/${account.id}`);
    };

    const handleOpenHistory: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        setOpen(true);
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Histórico (ALL)">
                <IconButton size="small" onClick={handleOpenHistory}>
                    <HistoryIcon sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>

            <HistoryAllModal
                open={open}
                onClose={() => setOpen(false)}
                identification={account.document}
            />
        </Grid>
    );
};
